(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3504],{

/***/ 51259:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/[blogSlug]",
      function () {
        return __webpack_require__(52818);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 24100:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/defaultpic.119a8e64.webp","height":269,"width":264,"blurDataURL":"data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoIAAgAAkA4JaQAA3AA/vgQAAA=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 52818:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _blogSlug_; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 19 modules
var es = __webpack_require__(81043);
// EXTERNAL MODULE: ./components/blog/blog.module.scss
var blog_module = __webpack_require__(12359);
var blog_module_default = /*#__PURE__*/__webpack_require__.n(blog_module);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./images/defaultpic.webp
var defaultpic = __webpack_require__(24100);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/blog/BlogPost.tsx








var BlogPost = function(props) {
    var layout = props.layout, blog = props.blog, domain = props.domain, dbName = props.dbName, forBLogType = props.forBLogType;
    var postClasses = classnames_default()((blog_module_default()).typography, layout === "full" && (blog_module_default())["typography--expanded"]);
    if (!blog) {
        return null;
    }
    var createMarkup = function(item) {
        return {
            __html: item
        };
    };
    var rightDate = blog.published_at ? (0,utils/* createRightDate */.UE)(blog.published_at) : (0,utils/* createRightDate */.UE)(blog.created_at);
    var blogDefaultImage = blog.image ? (0,helper/* domainUrl */.HJ)("".concat(dbName, "/storage/").concat(domain, "/").concat(blog.image)) : (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(defaultpic/* default.src */.Z.src));
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "block ".concat((blog_module_default())["post--layout--".concat(layout)]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (blog_module_default())["post-header--layout--".concat(layout)],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: (blog_module_default())["post-header__title"],
                        children: forBLogType === "blog" ? blog.blog_title : blog.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (blog_module_default())["post-header__meta"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (blog_module_default())["post-header__meta-item"],
                            children: [
                                " ",
                                rightDate
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (blog_module_default()).post__featured,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: blogDefaultImage,
                    alt: "Blog Image",
                    placeholder: "blur",
                    layout: "fill",
                    priority: true,
                    blurDataURL: "/zega/blur1.webp"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: postClasses,
                dangerouslySetInnerHTML: createMarkup((0,utils/* replaceDescr */.lz)(forBLogType === "blog" ? blog.html_content : blog.description))
            })
        ]
    });
};
/* harmony default export */ var blog_BlogPost = (BlogPost);

// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
;// CONCATENATED MODULE: ./components/blog/BlogPagePost.tsx






var BlogPagePost = function(param) {
    var forBLogType = param.forBLogType, breadcrumb = param.breadcrumb, layout = param.layout, blogSlug = param.blogSlug, propsBlog = param.blog, locale = param.locale, domain = param.domain;
    var content;
    var blogOne;
    var ref = (0,react.useState)(propsBlog[0]), blog = ref[0], setBlog = ref[1];
    var ref1 = (0,react.useState)(), redirect = ref1[0], _ = ref1[1];
    var dbName = (0,es/* useSelector */.v9)(function(state) {
        return state.general.dbName;
    });
    var prevBlogSlugRef = (0,react.useRef)();
    var prevLocaleCodeRef = (0,react.useRef)();
    (0,react.useEffect)(function() {
        prevBlogSlugRef.current = blogSlug;
        prevLocaleCodeRef.current = locale;
    }, []);
    (0,react.useEffect)(function() {
        if (prevBlogSlugRef.current !== blogSlug || prevLocaleCodeRef.current !== locale) {
            setBlog(propsBlog[0]);
            prevBlogSlugRef.current = blogSlug;
            prevLocaleCodeRef.current = locale;
        }
    }, [
        blogSlug,
        locale
    ]);
    if (redirect) {
    ///  return router.push("/404");
    }
    if (blog) {
        blogOne = blog;
    }
    content = /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "row ".concat((blog_module_default()).blog_container),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogPost, {
            forBLogType: forBLogType,
            blog: blogOne,
            dbName: dbName,
            layout: layout,
            domain: domain
        })
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "page",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                dbName: dbName,
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: content
            })
        ]
    });
};
/* harmony default export */ var blog_BlogPagePost = (BlogPagePost);

// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 32 modules
var MainLayout = __webpack_require__(75947);
;// CONCATENATED MODULE: ./pages/blog/[blogSlug].tsx









var Blog = function(pageProps) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var dbName = pageProps.dbName, domain = pageProps.domain, selectedLocale = pageProps.selectedLocale, breadcrumb = pageProps.breadcrumb, blog = pageProps.blog, siteName = pageProps.siteName, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var router = (0,next_router.useRouter)();
    var query = router.query;
    var meta_title = ((ref = blog[0]) === null || ref === void 0 ? void 0 : ref.meta_title) || ((ref1 = blog[0]) === null || ref1 === void 0 ? void 0 : ref1.blog_title);
    var meta_description = ((ref2 = blog[0]) === null || ref2 === void 0 ? void 0 : ref2.meta_description) || ((ref3 = blog[0]) === null || ref3 === void 0 ? void 0 : ref3.blog_title);
    var meta_keywords = ((ref4 = blog[0]) === null || ref4 === void 0 ? void 0 : ref4.meta_keywords) || ((ref5 = blog[0]) === null || ref5 === void 0 ? void 0 : ref5.blog_title);
    var meta_image = (ref6 = blog[0]) === null || ref6 === void 0 ? void 0 : ref6.image;
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    (0,react.useEffect)(function() {
        window.onpopstate = function() {
            router.push(window.location.pathname);
        };
    }, [
        query.pageSlug,
        selectedLocale,
        router.route
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "generator",
                            content: "Zegashop.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "robots",
                            content: "index, follow"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:image",
                            content: meta_image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:image",
                            content: meta_image
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:url",
                            content: meta_url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:locale",
                            content: selectedLocale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:site_name",
                            content: siteName
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: meta_url
                        }),
                        (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: "x-default"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: defaultLangCode
                                }),
                                locales.map(function(intl) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                        hrefLang: intl.code
                                    });
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(blog_BlogPagePost, {
                    dbName: dbName,
                    breadcrumb: breadcrumb,
                    blogSlug: query.blogSlug,
                    locale: selectedLocale,
                    blog: blog,
                    domain: domain,
                    forBLogType: "blog"
                })
            ]
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ var _blogSlug_ = (Blog);


/***/ }),

/***/ 12359:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"posts-list__item":"blog_posts-list__item__4uaQl","posts-list--layout--classic":"blog_posts-list--layout--classic__WWwea","posts-list--layout--list":"blog_posts-list--layout--list__g627c","posts-list__body":"blog_posts-list__body__lxGlV","posts-list--layout--grid":"blog_posts-list--layout--grid__gtNkO","blog-page-title":"blog_blog-page-title__H8_8b","posts-view__pagination":"blog_posts-view__pagination__P_36F","products-view__empty":"blog_products-view__empty__i1ia1","products-view__empty-title":"blog_products-view__empty-title__MyAiZ","blog_container":"blog_blog_container__7F5F0","typography":"blog_typography__s8_hG","typography--expanded":"blog_typography--expanded__t9afl","post--layout--full":"blog_post--layout--full__xReiC","post__featured":"blog_post__featured__5EXDf","post-header--layout--classic":"blog_post-header--layout--classic__FlmrF","post-header__categories":"blog_post-header__categories__8knrc","post-header__title":"blog_post-header__title___ScKl","post-header__meta":"blog_post-header__meta__Z76lA","post-header--layout--full":"blog_post-header--layout--full__VXW_j","post-header__meta-item":"blog_post-header__meta-item__tKFfe"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,3997,4531,9774,2888,179], function() { return __webpack_exec__(51259); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);